export default __webpack_public_path__ + "static/media/HGG-fullLogo.756dcec2.svg";